import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'

import { Grid, Row, Col } from 'react-bootstrap'
import { PageTitle } from 'Components/PageTitle'
import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import PinUserIcon from 'Assets/Images/icons/pinUser'
import { PATHS } from 'Config/Routing/paths'
import AmbassadorUploadDocumentsWrapper from './UploadDocumentsForm'
import { getBrandAmbassadorByID, updateUserDocument } from '../gql'
import { SectionTitleV2 } from '../../../../../Components/Section/SectionTitleV2'
import GenericFlatButton from '../../../../../Components/GenericFlatButton'
import StyledBreadcrumbs from '../../../../../Components/StyledBreadcrumbs'

const BreadcrumbsAmbassadorUploadDocuments = ({ currentPath }) => {
  return (
    <div>
      <StyledBreadcrumbs
        icon={<PinUserIcon style={{ width: 16 }} />}
        breadcrumbs={[
          {
            label: 'Dashboard',
            link: `${PATHS.main.dashboard}`,
          },
          {
            label: 'Cities',
            link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
          },
          {
            label: 'Brand Ambassadors',
            link: currentPath.replace('/upload-documents', ''),
          },
          {
            label: 'Documents',
          },
        ]}
      />
    </div>
  )
}

const AmbassadorUploadDocuments = ({ countryCode }) => {
  const [ambassador, setAmbassador] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const match = useRouteMatch()

  const getAmbassador = async () => {
    setIsLoading(true)
    const res = await getBrandAmbassadorByID({
      ambassadorId: match.params.ambassadorId,
      onlyPrimary: false,
    })
    const result = await res.json()
    const {
      data: { brandAmbassador },
    } = result
    setAmbassador(brandAmbassador)
    setIsLoading(false)
  }

  useEffect(() => {
    getAmbassador()
  }, [])

  const onDocumentUpdate = async input => {
    try {
      await updateUserDocument({ input })
    } catch (error) {
      /* eslint-disable */
      console.log(`UPDATE_DOC_ERROR:${error}`)
    }
  }

  return (
    <HideWhenBlocked>
      <AmbassadorWrapper>
        <BreadcrumbsAmbassadorUploadDocuments currentPath={match.url} />
        <PageTitle>
          {ambassador.firstName} {ambassador.lastName}
          {ambassador.status && (
            <span className="status">({ambassador.status})</span>
          )}
        </PageTitle>

        <AmbassadorSection>
          <Grid fluid>
            <Row>
              <Col xs={10}>
                <SectionTitleV2>BA files history</SectionTitleV2>
              </Col>
              <Col xs={2}>
                <GenericFlatButton
                  title={'BA profile'}
                  type={'outline'}
                  onClick={() => {
                    const curentUrl = match.url.replace('/upload-documents', '')
                    window.open(curentUrl, '_parent')
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                {ambassador.id && !isLoading && (
                  <AmbassadorUploadDocumentsWrapper
                    ambassador={ambassador}
                    countryCode={countryCode}
                    onDocumentUpdate={onDocumentUpdate}
                    getAmbassador={getAmbassador}
                  />
                )}
              </Col>
            </Row>
          </Grid>
        </AmbassadorSection>
      </AmbassadorWrapper>
    </HideWhenBlocked>
  )
}

export default AmbassadorUploadDocuments
